import type { MealStatus } from '@/features/meal/domain/enums/MealStatus'

export class MealMonitoringFilterEntity {
  regionIds!: Array<number>
  statuses!: Array<MealStatus>
  fetchAll?: boolean
  fromDate?: string
  toDate?: string
}
